"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SizeShrinker_1 = require("./SizeShrinker");
const SizeGrower_1 = require("./SizeGrower");
const ItemPositioner_1 = require("./ItemPositioner");
const ItemAligner_1 = require("./ItemAligner");
class LineLayout {
    constructor(layout, startIndex, endIndex, availableSpace) {
        this.layout = layout;
        this.startIndex = startIndex;
        this.endIndex = endIndex;
        this.availableSpace = availableSpace;
        this.crossAxisMaxLayoutSize = 0;
        this.items = layout.items;
    }
    getLayout() {
        return this.layout;
    }
    performLayout() {
        this._setItemSizes();
        this.setItemPositions();
        this._calcLayoutInfo();
    }
    _setItemSizes() {
        if (this.availableSpace > 0) {
            this._growItemSizes(this.availableSpace);
        }
        else if (this.availableSpace < 0) {
            this._shrinkItemSizes(-this.availableSpace);
        }
    }
    _growItemSizes(amount) {
        const grower = new SizeGrower_1.SizeGrower(this);
        grower.grow(amount);
        this.availableSpace -= grower.getGrownSize();
    }
    _shrinkItemSizes(amount) {
        const shrinker = new SizeShrinker_1.SizeShrinker(this);
        shrinker.shrink(amount);
        this.availableSpace += shrinker.getShrunkSize();
    }
    setItemPositions() {
        const positioner = new ItemPositioner_1.ItemPositioner(this);
        positioner.position();
    }
    createItemAligner() {
        return new ItemAligner_1.ItemAligner(this);
    }
    _calcLayoutInfo() {
        this._calcCrossAxisMaxLayoutSize();
    }
    getMainAxisMinSize() {
        let mainAxisMinSize = 0;
        for (let i = this.startIndex; i <= this.endIndex; i++) {
            const item = this.items[i];
            mainAxisMinSize += item.flexItem.getMainAxisMinSizeWithPaddingAndMargin();
        }
        return mainAxisMinSize;
    }
    get numberOfItems() {
        return this.endIndex - this.startIndex + 1;
    }
    get crossAxisLayoutSize() {
        const noSpecifiedCrossAxisSize = this.layout.isCrossAxisFitToContents() && !this.layout.isResizingCrossAxis();
        const shouldFitToContents = this.layout.isWrapping() || noSpecifiedCrossAxisSize;
        if (shouldFitToContents) {
            return this.crossAxisMaxLayoutSize;
        }
        else {
            return this.layout.crossAxisSize;
        }
    }
    _calcCrossAxisMaxLayoutSize() {
        this.crossAxisMaxLayoutSize = this._getCrossAxisMaxLayoutSize();
    }
    _getCrossAxisMaxLayoutSize() {
        let crossAxisMaxSize = 0;
        for (let i = this.startIndex; i <= this.endIndex; i++) {
            const item = this.items[i];
            crossAxisMaxSize = Math.max(crossAxisMaxSize, item.flexItem.getCrossAxisLayoutSizeWithPaddingAndMargin());
        }
        return crossAxisMaxSize;
    }
}
exports.LineLayout = LineLayout;
//# sourceMappingURL=LineLayout.js.map